export default __webpack_public_path__ + "static/bg_squares_big-4ab2704ccd8264a97ad50007e722105e.svg";